import React, { Component } from "react"
import PropTypes from "prop-types"

import {
  MyMazdaVehicleList,
  Hyperlink,
  WysiwygContent,
  ExpandableArea
} from "components"
import { Section, Button, H2, P } from "AtomicComponents"

import { MyMazdaRemoveVehicleFlow, MyMazdaAddVehiclFlow, Column, ColumnGroup } from "containers"
import { isLocalStorageSupported, removeLocal, getLocal } from "apis/persist"

const addStatus = status => item => ({ ...item, status })
const addDisabled = item => ({ ...item, disabled: true })

class MyMazdaManageVehiclesBlock extends Component {
  constructor() {
    super()
    this.state = {
      showRemoveVehicleFlow: false,
      removeVehicleIndex: 0,
      showAddVehicleFlow: false
    }
  }
  render() {
    const {
      ownedVehicleDataList,
      drivenVehicleDataList,
      reservedVehicleDataList,
      requestedVehicleDataList,
      leasedVehicleDataList,
      nextServiceDisclaimer,
      errorMessage
    } = this.props
    const vehicles = [
      ...ownedVehicleDataList,
      ...drivenVehicleDataList,
      ...reservedVehicleDataList.map(addStatus("Vehicle reserved")).map(addDisabled),
      ...requestedVehicleDataList.map(addStatus("Transfer requested")).map(addDisabled),
      ...leasedVehicleDataList
    ]
    const { showRemoveVehicleFlow, removeVehicleIndex, showAddVehicleFlow } = this.state
    return (
      <Section backgroundColor="#FFFFFF" padding>
        <H2 withDetails>Manage Vehicles</H2>
        <MyMazdaVehicleList
          dashboardButtonText={"View Dashboard"}
          removeButtontext={"Remove Vehicle"}
          removeOnClick={index =>
            this.setState({ showRemoveVehicleFlow: true, removeVehicleIndex: index })
          }
          nextServiceDisclaimer={nextServiceDisclaimer}
          vehicles={vehicles} />
        {showRemoveVehicleFlow && (
          <MyMazdaRemoveVehicleFlow
            {...this.props.removeVehicleProps}
            vehicle={vehicles[removeVehicleIndex]}
            onClose={() => {
              if (isLocalStorageSupported && getLocal("addRemoveVehicleLastStep")) {
                removeLocal("addRemoveVehicleLastStep")
                window.location.reload()
              }
              this.setState({ showRemoveVehicleFlow: false })
            }} />
        )}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
          <P>{this.props.addVehicleProps.addVehicleDescription}</P>
          <Button
            styleName={"blackOutlined"}
            onClick={() => this.setState({ showAddVehicleFlow: true })}
            customWrapperStyle={{ margin: "0 auto" }}>
            {this.props.addVehicleProps.addVehicleButtonText}
          </Button>
          <ExpandableArea>
            {({ RenderArea, toggleExpanded }) => (
              <div style={{ margin: "2em 0 0" }}>
                <Hyperlink onClick={toggleExpanded} styleName="black">
                  {this.props.addVehicleProps.vinHitLabel}
                </Hyperlink>
                <RenderArea>
                  <p style={{ fontSize: "90%", color: "#aaaaaa", padding: "1em 0" }}>
                    {this.props.addVehicleProps.vinHintDescription}
                  </p>
                </RenderArea>
              </div>
            )}
          </ExpandableArea>
        </div>
        {showAddVehicleFlow && (
          <MyMazdaAddVehiclFlow
            {...this.props.addVehicleProps}
            errorMessage={errorMessage}
            onClose={() => {
              if (isLocalStorageSupported && getLocal("addRemoveVehicleLastStep")) {
                removeLocal("addRemoveVehicleLastStep")
                window.location.reload()
              }
              this.setState({ showAddVehicleFlow: false })
            }} />
        )}
      </Section>
    )
  }
}

MyMazdaManageVehiclesBlock.propTypes = {
  ownedVehicleDataList: PropTypes.array,
  drivenVehicleDataList: PropTypes.array,
  reservedVehicleDataList: PropTypes.array,
  requestedVehicleDataList: PropTypes.array,
  leasedVehicleDataList: PropTypes.array,
  nextServiceDisclaimer: PropTypes.string,
  errorMessage: PropTypes.string,
  removeVehicleProps: PropTypes.shape({
    removeVehicleEndpoint: PropTypes.string,
    removeDescription: PropTypes.string,
    confirmationDescription: PropTypes.string
  }),
  addVehicleProps: PropTypes.shape({
    addVehicleConfirmationDescription: PropTypes.string,
    addVehicleDescription: PropTypes.string,
    addVehicleButtonText: PropTypes.string,
    addVehicleDescriptionExtended: PropTypes.string,
    addVehicleHeading: PropTypes.string,
    addSearchButtonText: PropTypes.string,
    retrySearchButtonText: PropTypes.string,
    confirmHeading: PropTypes.string,
    confirmButtonText: PropTypes.string,
    vehicleSearchEndPoint: PropTypes.string,
    vinHitLabel: PropTypes.string,
    vinHintDescription: PropTypes.string,
    linkVehicleEndPoint: PropTypes.string
  })
}

MyMazdaManageVehiclesBlock.defaultProps = {
  ownedVehicleDataList: [],
  drivenVehicleDataList: [],
  reservedVehicleDataList: [],
  requestedVehicleDataList: [],
  removeVehicleProps: {
    removeVehicleEndpoint: "/api/mymazda/vehicle/",
    confirmationDescription:
      "<p>By removing this vehicle you are updating the Mazda New Zealand database...</p><p>Do you wish to remove this vehicle?</p>",
    removeDescription:
      "<p>You've requested to remove the $nameplate$ $bodyStyle$ [$registrationNumber$]. Please confirm the reason you're removing this vehicle.</p>"
  },
  addVehicleProps: {
    addVehicleButtonText: "+ Add Vehicle",
    addVehicleDescription: "Add as second hand vehicle with a registration or VIN number.",
    addVehicleDescriptionExtended:
      "Add a second vehicle to your MyMazda account using your registration number or Vehicle Registration Number (VIN)",
    retrySearchButtonText: "Search Again",
    addVehicleHeading: "Add A Vehicle",
    addSearchButtonText: "Search",
    confirmHeading: "Confirm your vehicle",
    confirmButtonText: "Add Vehicle",
    vinHitLabel: "Where is my VIN located?",
    vinHintDescription:
      "The Vehicle Identification Number [VIN] is a unique number that identifies your vehicle. Please refer to the Specifications section of your owner's manual for the exact location of this number.",
    vehicleSearchEndPoint: "/api/model-details",
    linkVehicleEndPoint: "/api/mymazda/vehicle"
  }
}

export default MyMazdaManageVehiclesBlock



// WEBPACK FOOTER //
// ./src/blocks/mymazda/manage-vehicles/index.jsx